module.exports = __webpack_public_path__ + "static/media/NoacloudLogoBlanco.0f6446b7.png";